/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
import store from '../store'
export default [
  {
    path: '*',
    meta: {
      name: '',
      requiresAuth: true
    },
    redirect: {
      path: '/'
    }
  },
  // This  allows you to have pages apart of the app but no rendered inside the dash
  {
    path: '/',
    meta: {
      name: 'Login',
      requiresAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "routes" */ `@/views/LoginHome.vue`),
    // redirect if already signed in
    beforeEnter: (to, from, next) => {
      if (store.getters.authorized && to.path === '/') {
          let user = JSON.parse(localStorage.getItem('userInfo'))
          if (user && user.type) {
              if (user.type === 'admin') {
                next('/dashboard/user-profile')
              } else {
                next('/dashboard/affiliate-profile')
              }
          } else {
              next()
          }
      } else {
        next()
      }
    },
    children: [
      {
        path: '',
        component: () => import(`@/components/LoginForm.vue`)
      },
      {
        path: '/forgot-password',
        component: () => import(`@/components/ForgotPasswordView.vue`)
      },
      {
        path: '/affiliates/invite/:code',
        component: () => import(`@/components/AffiliateInvite.vue`)
      }
    ]
  },
  // add any extra routes that you want rendered in the dashboard as a child below. Change toolbar names here
  {
    path: '/dashboard',
    meta: {
      name: 'Dashboard View',
      requiresAuth: true
    },
    component: () => import(`@/views/DashboardView.vue`),
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import(`@/components/DashViews/Dashboard.vue`)
      },
      {
        path: 'affiliate-dashboard',
        name: 'Dashboard',
        component: () => import(`@/components/DashViews/AffiliateDashboard.vue`)
      },
      {
        path: 'user-profile',
        meta: {
          name: 'User Profile',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/UserProfile.vue`)
      },
      {
        path: 'affiliate-profile',
        meta: {
          name: 'Affiliate Profile',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/AffiliateProfile.vue`)
      },
      {
        path: 'table-list',
        meta: {
          name: 'Table List',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/SimpleTables.vue`)
      },
      {
        path: 'affiliates',
        meta: {
          name: 'Affiliates',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/AffiliateList.vue`)
      },
      {
        path: 'clients',
        meta: {
          name: 'Clients',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/ClientList.vue`)
      },
      {
        path: 'services',
        meta: {
          name: 'Services',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/ServiceList.vue`)
      },
      {
        path: 'categories',
        meta: {
          name: 'Categoreis',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/CategoryList.vue`)
      },
        {
            path: 'stores',
            meta: {
                name: 'Stores',
                requiresAuth: true
            },
            component: () => import(`@/components/DashViews/StoreList.vue`)
        },
      {
        path: 'products',
        meta: {
          name: 'Products',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/ProductList.vue`)
      },
      {
        path: 'affiliates/services',
        meta: {
          name: 'Services',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/AffiliateServiceList.vue`)
      },
      {
        path: 'subscriptions',
        meta: {
          name: 'Subscriptions',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/SubscriptionList.vue`)
      },
      {
        path: 'clients/subscriptions',
        meta: {
          name: 'Subscriptions',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/AffiliateSubscriptionList.vue`)
      },
      {
        path: 'tablestest',
        meta: {
          name: 'Complex Tables test',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/TableList.vue`)
      },
      {
        path: 'typography',
        meta: {
          name: 'Typography',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/Typography.vue`)
      },
      {
        path: 'icons',
        meta: {
          name: 'Icons',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/Icons.vue`)
      },
      {
        path: 'maps',
        meta: {
          name: 'Maps',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/Maps.vue`)
      },
      {
        path: 'notifications',
        meta: {
          name: 'Notifications',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/Notifications.vue`)
      }
    ]
  }
]
